import type { updateTradeSettingsInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetConfiguration: undefined;
	useUpdateTradeSettings: updateTradeSettingsInput;
}

const TRADE_SETTINGS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"trade_settings",
	["useGetConfiguration", "useUpdateTradeSettings"],
);

export { TRADE_SETTINGS_SERVICE_KEYS };
